import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { NextArrowIcon } from "@Icons/MainIcons";
import { SubMenuItem } from "src/constants/modules";
import { MODULE_STYLE } from "../../constants";

const ModuleTile: FC<{ item: SubMenuItem }> = ({ item }) => {
  const { t } = useTranslation();
  return (
    <Link
      to={`${item.route}`}
      className="group relative flex h-full w-full shrink-0 cursor-pointer flex-col overflow-hidden rounded-xl text-start transition-all duration-200 hover:shadow-md"
    >
      <img
        src={MODULE_STYLE[item.type]?.image}
        alt={item.type}
        className="h-full w-full bg-background-subtle object-cover transition-transform duration-300 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-background-overlay/80 via-background-overlay/20 to-transparent" />
      <div className="absolute bottom-4 flex w-full items-end justify-between gap-3 px-4 md:bottom-10 md:items-center md:px-7">
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <div className="text-font-inverted text-lg font-medium">{t(item.label)}</div>
          <div className="text-font-inverted line-clamp-1 text-xs opacity-80 md:line-clamp-none md:text-sm md:opacity-100">
            {t(`${item.label}Subtitle`)}
          </div>
        </div>
        <div className="text-font-default shrink-0 rounded-full bg-background-default p-2.5 md:p-3">
          <NextArrowIcon className="w-3 h-3"/>
        </div>
      </div>
    </Link>
  );
};

export default ModuleTile;
